import { motion } from "framer-motion";

const IMG =
  "https://images.unsplash.com/photo-1652303518379-c0ef1c9fb2b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJzJTIwaGFyZGhhdHxlbnwwfHx8fDE3ODQwNTcxODB8MA&ixlib=rb-4.1.0&q=85";

const CHAPTERS = [
  {
    n: "01",
    title: "Precision as principle",
    body: "Every millimetre is accounted for. We plan, model and build with tolerances that leave nothing to chance.",
  },
  {
    n: "02",
    title: "Safety without compromise",
    body: "Zero-harm sites are non-negotiable. Our teams are trained, certified and accountable at every stage.",
  },
  {
    n: "03",
    title: "Built to outlast",
    body: "We specify materials and methods for longevity — structures engineered to serve for generations.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.12 } }),
};

export const Manifesto = () => {
  return (
    <section id="manifesto" className="bg-surface py-24 md:py-36 border-y border-line" data-testid="manifesto">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-flame" />
              <span className="text-xs uppercase tracking-[0.35em] text-secondary-foreground/80">The Studio</span>
            </div>
            <h2 className="font-heading font-black tracking-tighter text-4xl md:text-6xl leading-[0.95] mb-8">
              A builder's mindset, an engineer's discipline.
            </h2>
            <div className="relative overflow-hidden aspect-[4/3] border border-line">
              <motion.img
                initial={{ scale: 1.2 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
                src={IMG}
                alt="KTR construction team on site"
                className="h-full w-full object-cover grayscale hover:grayscale-0 transition-[filter] duration-700"
              />
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 flex flex-col">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              className="border-t border-line py-10 md:py-14 grid grid-cols-12 gap-4"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <span className="col-span-12 md:col-span-3 font-heading font-black text-flame text-6xl md:text-7xl tracking-tighter leading-none">
                {c.n}
              </span>
              <div className="col-span-12 md:col-span-9">
                <h3 className="font-heading font-bold tracking-tight text-3xl md:text-4xl mb-4">{c.title}</h3>
                <p className="text-secondary-foreground/75 text-lg max-w-xl">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
